// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/models/global';
import model_2 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/pages/ContractManagement/model';
import model_3 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/pages/ContractMarket/AlreadyDeployed/model';
import model_4 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/pages/ContractMarket/model';
import model_5 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/pages/ContractMarket/Mycontract/model';
import model_6 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/pages/Markdown/model';
import model_7 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/.umi-production/plugin-initialState/@@initialState';
import model_8 from '/app/jenkins/workspace/lmc/web/contract_market_frontend/src/.umi-production/plugin-qiankun-slave/qiankunModel';

export const models = {
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'ContractManagement.model', model: model_2 },
model_3: { namespace: 'ContractMarket.AlreadyDeployed.model', model: model_3 },
model_4: { namespace: 'ContractMarket.model', model: model_4 },
model_5: { namespace: 'ContractMarket.Mycontract.model', model: model_5 },
model_6: { namespace: 'Markdown.model', model: model_6 },
model_7: { namespace: '@@initialState', model: model_7 },
model_8: { namespace: '@@qiankunStateFromMaster', model: model_8 },
} as const
